module.exports = __webpack_public_path__ + "static/InterFace-Italic-1814e9dfc56382e22f52bc590d81611d.woff2";